import { useMutation } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const MUTATION = graphql(`
  mutation UpdateEpsonServerDirectPrint($id: ID!, $input: UpdateEpsonServerDirectPrintInput!) {
    updateEpsonServerDirectPrint(id: $id, input: $input) {
      id
      forwardTo
    }
  }
`);

export function useUpdateEpsonServerDirectPrint() {
  return useMutation(MUTATION, {
    refetchQueries: ['GetEpsonServerDirectPrint'],
  });
}
